import { FC } from 'react';
import { FormLabel, InputAdornment, TextFieldProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { Iconify, RHFTextField } from '@app/components';

type FilePickerFieldProps = {
  name: string;
  label: string;
} & TextFieldProps;

const RHFFilePickerField: FC<FilePickerFieldProps> = ({ name, label, ...other }) => {
  const { control } = useFormContext();

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormLabel
            className="file-field"
            htmlFor={`${name}-fileInput`}
            sx={{ display: 'flex', flexGrow: 1, cursor: 'pointer' }}
          >
            <RHFTextField
              name={name}
              label={label}
              sx={{ pointerEvents: 'none' }}
              onChange={field.onChange}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <Iconify icon="ep:upload-filled" />
                  </InputAdornment>
                ),
              }}
              {...other}
            />
            <input
              type="file"
              id={`${name}-fileInput`}
              style={{ display: 'none' }}
              onChange={(event) => {
                field.onChange(event.target.files?.[0].name);
              }}
            />
          </FormLabel>
        )}
      />
    </>
  );
};

export { RHFFilePickerField };
